import styled from '@emotion/styled'
import { WebNavLink } from '@news-mono/web-common'
import { breakpoint } from '../../../__styling/style-functions/breakpoint'
import { calcRem } from '../../../__styling/style-functions/calc-rem'
import { transition } from '../../../__styling/style-mixins'

interface MedalTallyStyleProps {
    isFullSize: boolean
}

export const StyledMedalTallyWrap = styled('div')<MedalTallyStyleProps>({
    height: '100%',
    background: 'white',
})

export const StyledWebLink = styled(WebNavLink)(({ theme }) => ({
    backgroundColor: theme.colors.actions.button.primary.background.default,
    color: theme.colors.actions.button.primary.text.default,
    alignItems: 'center',
    border: '1px solid',
    textDecoration: 'none',
    padding: calcRem(8, 7),
    width: '100%',
    fontSize: calcRem(13),
    fontWeight: 700,
    borderRadius: '3px',
    textAlign: 'center',
    ...transition({ properties: ['background-color', 'color'] }),
    [breakpoint('sm')]: {
        width: calcRem(91),
    },
    '&:not(:first-child)': {
        marginLeft: calcRem(10),
    },

    '&:hover': {
        backgroundColor: theme.colors.actions.button.primary.background.hover,
        color: theme.colors.actions.button.primary.text.hover,
    },

    '&:focus': {
        backgroundColor: theme.colors.actions.button.primary.background.hover,
        color: theme.colors.actions.button.primary.text.hover,
    },

    '&.isActive': {
        backgroundColor: theme.colors.actions.button.primary.background.hover,
        color: theme.colors.actions.button.primary.text.hover,

        '&:hover': {
            backgroundColor:
                theme.colors.actions.button.primary.background.default,
            color: theme.colors.actions.button.primary.text.default,
        },

        '&:focus': {
            backgroundColor:
                theme.colors.actions.button.primary.background.default,
            color: theme.colors.actions.button.primary.text.default,
        },
    },
}))
